export const environment = {
  production: true,
  apiBaseUrl: '',
  fixedDeviceId: null,
  stripeApiKey:
    'pk_test_51ItVxUE50DcUZQbEjKT6qWff7nLxPDtzgN2pqPNeJXonRb1eiy6h7qmn5yzfY0JJi3OfJtm5CAdAzaRcGPC0g5mN00hqw7GRAf',
};
